// extracted by mini-css-extract-plugin
export default {"ConfiguratorLayout":"configurator-module_ConfiguratorLayout_UJBcw"};